/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I mix units?`)
};

const es_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo combinar unidades?`)
};

const de_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich Einheiten mischen?`)
};

const nl_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik eenheden combineren?`)
};

const fr_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je mélanger les unités ?`)
};

const it_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso combinare le unità?`)
};

const pt_br2_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso misturar unidades?`)
};

const pt_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso misturar unidades?`)
};

const ja_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単位を混在させることはできますか？`)
};

const zh_massmol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以混用单位吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_faq_q3", locale)
	if (locale === "en") return en_massmol_faq_q3(inputs)
	if (locale === "es") return es_massmol_faq_q3(inputs)
	if (locale === "de") return de_massmol_faq_q3(inputs)
	if (locale === "nl") return nl_massmol_faq_q3(inputs)
	if (locale === "fr") return fr_massmol_faq_q3(inputs)
	if (locale === "it") return it_massmol_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_faq_q3(inputs)
	if (locale === "pt") return pt_massmol_faq_q3(inputs)
	if (locale === "ja") return ja_massmol_faq_q3(inputs)
	return zh_massmol_faq_q3(inputs)
};